import { IResolveOfferParameters } from './types';
import { IMapMappedResponse } from '../../../Map/types/mappedResponse';
import { fetchPublicWebV1Map } from '../../repositories/dailyrent/web/v1/map';
import { IApplicationContext } from '../../types/applicationContext';

export async function fetchClusters(
  context: IApplicationContext,
  parameters: IResolveOfferParameters,
): Promise<IMapMappedResponse> {
  const { params, subdomain, mappers } = parameters;
  const { httpApi, cancellationTokenManager } = context;

  const abortSignal = cancellationTokenManager?.getSignalAndCancelPrevious('fetchClusters');

  return (await fetchPublicWebV1Map({
    httpApi,
    parameters: { ...params, subdomain },
    config: { signal: abortSignal },
    mappers,
  })) as IMapMappedResponse;
}
